import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 text-xl font-bold" }, "On-chain Asset Store", -1)
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "mb-2 font-bold"
}
const _hoisted_4 = {
  key: 0,
  selected: "",
  disabled: "",
  value: ""
}
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = ["onClick", "src"]
const _hoisted_14 = {
  key: 0,
  class: "rounded-xs mt-2 mb-2 border p-2 shadow-md"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "mt-1 overflow-x-scroll" }
const _hoisted_17 = { class: "text-xs" }
const _hoisted_18 = { class: "mt-2" }
const _hoisted_19 = { class: "mt-2 overflow-x-scroll" }
const _hoisted_20 = { class: "text-xs" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KeyMessage = _resolveComponent("KeyMessage")!
  const _component_References = _resolveComponent("References")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_KeyMessage),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("storyView.message")), 1),
    (_ctx.assetCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("storyView.totalAssetCount")) + " : " + _toDisplayString(_ctx.assetCount), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("select", {
      class: "form-select block w-full rounded border border-solid border-gray-300 bg-white bg-clip-padding bg-no-repeat px-3 py-1.5 text-base font-normal text-gray-700",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGroup) = $event))
    }, [
      (_ctx.groups.length === 0)
        ? (_openBlock(), _createElementBlock("option", _hoisted_4, _toDisplayString(_ctx.$t("storyView.loadingGroups")), 1))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.groups, (group) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: group.key
            }, [
              (group.key === '')
                ? (_openBlock(), _createElementBlock("option", {
                    key: 0,
                    value: group.key,
                    disabled: ""
                  }, _toDisplayString(group.value), 9, _hoisted_5))
                : (_openBlock(), _createElementBlock("option", {
                    key: 1,
                    value: group.key
                  }, _toDisplayString(group.value), 9, _hoisted_6))
            ], 64))
          }), 128))
    ], 512), [
      [_vModelSelect, _ctx.selectedGroup]
    ]),
    (_ctx.categories.length > 0)
      ? _withDirectives((_openBlock(), _createElementBlock("select", {
          key: 1,
          class: "form-select mt-2 block w-full rounded border border-solid border-gray-300 bg-white bg-clip-padding bg-no-repeat px-3 py-1.5 text-base font-normal text-gray-700",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCategory) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: category }, [
              (category.key === '')
                ? (_openBlock(), _createElementBlock("option", {
                    key: 0,
                    value: category.key,
                    disabled: ""
                  }, _toDisplayString(category.value), 9, _hoisted_7))
                : (_openBlock(), _createElementBlock("option", {
                    key: 1,
                    value: category.key
                  }, _toDisplayString(category.value), 9, _hoisted_8))
            ], 64))
          }), 128))
        ], 512)), [
          [_vModelSelect, _ctx.selectedCategory]
        ])
      : (_ctx.selectedGroup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("storyView.loadingCategories")), 1)
          ]))
        : _createCommentVNode("", true),
    (_ctx.assets.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("storyView.selectAssets")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assets, (asset) => {
            return (_openBlock(), _createElementBlock("span", {
              key: asset.assetId
            }, [
              _createElementVNode("img", {
                onClick: 
            () => {
              _ctx.assetSelected(asset);
            }
          ,
                src: asset.image,
                class: "inline-block w-12 cursor-pointer rounded-xl"
              }, null, 8, _hoisted_13),
              (asset.assetId == _ctx.selectedAsset?.assetId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_ctx.selectedAsset.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("p", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t("storyView.sampleCodeMessage")) + " ", 1),
                            _createElementVNode("button", {
                              class: "rounded-md border pl-2 pr-2 shadow-md",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copySample && _ctx.copySample(...args)))
                            }, _toDisplayString(_ctx.$t("message.copy")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("pre", _hoisted_17, _toDisplayString(_ctx.sampleCode), 1)
                          ]),
                          _createElementVNode("p", _hoisted_18, [
                            _createTextVNode(_toDisplayString(_ctx.$t("storyView.fetchedImage")) + " ", 1),
                            _createElementVNode("button", {
                              class: "rounded-md border pl-2 pr-2 shadow-md",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.copySVG && _ctx.copySVG(...args)))
                            }, _toDisplayString(_ctx.$t("message.copy")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("pre", _hoisted_20, _toDisplayString(asset.svg), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("img", {
                              src: asset.image,
                              class: "inline-block w-64 cursor-pointer rounded-xl"
                            }, null, 8, _hoisted_21)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_22, "..."))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : (_ctx.selectedCategory)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("storyView.loadingAssets")), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_References, { EtherscanStore: _ctx.EtherscanStore }, null, 8, ["EtherscanStore"])
  ]))
}